export default __webpack_public_path__ + "static/media/profile.e629d4c4.png";